import { render, staticRenderFns } from "./ViewNotifications.vue?vue&type=template&id=a0a4364c&scoped=true"
import script from "./ViewNotifications.vue?vue&type=script&lang=js"
export * from "./ViewNotifications.vue?vue&type=script&lang=js"
import style0 from "./ViewNotifications.vue?vue&type=style&index=0&id=a0a4364c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a4364c",
  null
  
)

export default component.exports